import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ConfiguratorLibrariesView } from "src/components/views/erp/configurator/managing/libraries/ConfiguratorLibrariesView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/configurator/libraries")({
	staticData: { title: i18n.t("libraries"), legacyViewKey: "configuratorLibrariesView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ConfiguratorLibrariesView />;
}
